import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';
import { t } from 'utils/translates';

// eslint-disable-next-line react/prefer-stateless-function
class TaskPanelHeaderAsExec extends Component {
  getTitle = () => {
    if (this.props.typeLayout === 'view') {
      return this.props.task.title;
    }
    if (this.props.isTaskFromAuthUser) {
      return (
        <NavLink
          to={`/my-tasks/view/${this.props.task.id}/desc`}
          title={this.props.task.title}
        >
          {this.props.task.title}
        </NavLink>
      );
    }
    return (
      <NavLink
        to={`/earn-money/task-view/${this.props.task.id}`}
        title={this.props.task.title}
      >
        {this.props.task.title}
      </NavLink>
    );
  };

  getHostName = () => {
    try {
      const { hostname } = new URL(this.props.task.base_link);
      return hostname;
    } catch (error) {
      return null;
    }
  };

  // Метод для определения отображения конкретной категории для отображения значка pinned для закрепленных в категории
  isTypesExistInQueryParams = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const typesIdsValue = searchParams.get('tasksToExecutorsList[type_ids]');
    return typesIdsValue && typesIdsValue.length > 0;
  };

  render() {
    const title = this.getTitle();
    const isPinned =
      this.props.task.is_pinned ||
      (this.props.task.is_pinned_by_category &&
        this.isTypesExistInQueryParams());
    return (
      <div className="panel-heading panel-inner-border-bottom">
        <div className="task-table">
          <div className="task-cell">
            <h2 className="h3 task-title" title={this.props.task.title}>
              {title}
            </h2>
          </div>
          <div className="task-cell task-price">
            <div className="task-price-val">
              <span className="h3">{this.props.task.cost}</span> ₽
            </div>
          </div>
        </div>
        <ul className="list-inline task-info">
          {isPinned && (
            <li
              data-toggle="tooltip"
              data-container="body"
              data-placement="top"
              title=""
              data-original-title={t('Задание закреплено')}
            >
              <i className="fa fa-lg fa-thumb-tack text-ok" />
            </li>
          )}
          {this.props.task.is_highlighted && (
            <li
              data-toggle="tooltip"
              data-container="body"
              data-placement="top"
              title=""
              data-original-title={t('Задание выделено')}
            >
              <i className="fa fa-flash fa-lg text-ok" />
            </li>
          )}
          <li className="text-muted">
            {formatter.dateFormat3(this.props.task.created_at)}
          </li>
          <li className="text-muted">ID{this.props.task.id}</li>
          <li title={`${this.props.task.base_link}`}>
            <a
              className="text-success text-underline"
              target="_blank"
              rel="noopener noreferrer"
              href={`${this.props.task.base_link}`}
            >
              {this.getHostName()}
            </a>
          </li>
          <li>
            <NavLink
              to={`/users/profile/${this.props.task.owner.id}`}
              className="text-muted"
            >
              <div className="media media_inline-table">
                <div className="media-left">
                  <img
                    alt={''}
                    className="media-object avatar avatar-xxs"
                    src={this.props.task.owner.avatarUrl}
                  />
                </div>
                <div className="media-body media-middle">
                  <div
                    className="text-overflow text-overflow_sm"
                    title={this.props.task.owner.username}
                  >
                    {this.props.task.owner.username}
                  </div>
                </div>
              </div>
            </NavLink>
          </li>
        </ul>
      </div>
    );
  }
}

TaskPanelHeaderAsExec.defaultProps = {
  typeLayout: 'list'
};

TaskPanelHeaderAsExec.propTypes = {
  isTaskFromAuthUser: PropTypes.bool.isRequired,
  typeLayout: PropTypes.oneOf(['list', 'view']),
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    base_link: PropTypes.string.isRequired,
    cost: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    is_pinned: PropTypes.bool.isRequired,
    is_pinned_by_category: PropTypes.bool.isRequired,
    is_highlighted: PropTypes.bool.isRequired,
    owner: PropTypes.shape({
      id: PropTypes.number.isRequired,
      username: PropTypes.string.isRequired,
      status: PropTypes.number.isRequired,
      avatarUrl: PropTypes.string.isRequired
    })
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(TaskPanelHeaderAsExec);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksToExecutorsList/TasksToExecutorsListItem/TasksToExecutorsListItemHeader/index.js